var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.isLoading)?_c('v-skeleton-loader',{attrs:{"height":"300px","type":"card-heading, image"}}):_vm._e(),(_vm.chartOptions && !_vm.isLoading)?_c('highcharts',{attrs:{"options":_vm.chartOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }